// ICOPE知识库服务 - 从预编译的JSON文件加载数据
import knowledgeBaseData from '../data/knowledge-base.json';
import { DOMAIN_KNOWLEDGE_MAPPING } from '../data/constants';

// 知识库数据结构
export interface KnowledgeBlock {
  uid: string;
  title: string;
  type: string;
  domain: string;
  pathway_step: string;
  audience: string;
  tags: string[];
  related: string[];
  source_chapter: string;
  source_page: string;
  content: string;
  verbatim_content: string;
}

// 知识块检索服务
export class KnowledgeBaseService {
  private knowledgeBase: Record<string, KnowledgeBlock>;

  constructor() {
    this.knowledgeBase = knowledgeBaseData;
    // The console log will now appear in the browser's console
    console.log(`Knowledge base loaded from pre-compiled JSON. Total blocks: ${Object.keys(this.knowledgeBase).length}`);
  }

  getKnowledgeBlock(uid: string): KnowledgeBlock | null {
    return this.knowledgeBase[uid] || null;
  }

  getKnowledgeBlocks(uids: string | string[]): KnowledgeBlock[] {
    if (!uids) return [];
    const uidsArray = Array.isArray(uids) ? uids : [uids];
    return uidsArray.map(uid => this.knowledgeBase[uid]).filter(Boolean);
  }

  getRelatedBlocks(uid: string): KnowledgeBlock[] {
    const block = this.getKnowledgeBlock(uid);
    if (!block || !block.related) return [];
    
    // 加固逻辑：确保related字段即使是单个字符串也能被处理
    const relatedUids = Array.isArray(block.related) ? block.related : [block.related];
    
    return this.getKnowledgeBlocks(relatedUids);
  }
  
  getRecommendedKnowledgeBlocks(domain: string, status: 'pass' | 'fail' | 'ok' | 'needsAttention'): KnowledgeBlock[] {
    const mapping = DOMAIN_KNOWLEDGE_MAPPING[domain as keyof typeof DOMAIN_KNOWLEDGE_MAPPING];
    if (!mapping) return [];

    let uids: string[] = [];
    
    if ('pass' in mapping && (status === 'pass' || status === 'ok')) {
      uids = mapping.pass;
    } else if ('fail' in mapping && (status === 'fail' || status === 'needsAttention')) {
      uids = mapping.fail;
    } else if ('ok' in mapping && status === 'ok') {
      uids = mapping.ok;
    } else if ('needsAttention' in mapping && status === 'needsAttention') {
      uids = mapping.needsAttention;
    }

    return this.getKnowledgeBlocks(uids);
  }
}

// 导出单例实例
export const knowledgeBaseService = new KnowledgeBaseService();